export class SpSadtExecutedProcedureProfessional {
    public idSpSadtExecutedProcedureProfessional: number;
    public idSpSadtExecutedProcedure: number;
    public idProfessionalAgreement: number;
    public datetimeInclusion: Date;
    public performedProcedureReferenceSequential: string;
}